import { useClientConfig } from '@framework/auth/client-config/ClientConfigSlice.tsx';
import { Route } from '@framework/ui/core/router/TypedRoute.tsx';
import { Switch } from 'react-router';
import { NotFoundPage } from '../errors/not-found/NotFoundPage.tsx';
import { VerifyPassPage } from './VerifyPassPage.tsx';

export default function VerifyPassRoutes() {
  const { applicationConfig } = useClientConfig();
  const canVerifyPass = applicationConfig?.flVerificaAlbo ?? false;

  if (!process.env.BUILD_FLAGS_VERIFY_PASS || !canVerifyPass) return null;

  return (
    <Switch>
      <Route path="/verifica-tesserini" exact component={VerifyPassPage} />
      {/* Il modulo è montato non-exact sul prefisso: senza fallback i path
          senza route dedicata restano bianchi */}
      <Route component={NotFoundPage} />
    </Switch>
  );
}
